import { useState, useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";

import { cn, colors } from "tools/ui";

const style =
  "z-10 px-4 pt-4 pb-2 bg-white shadow-md text-3xl cursor-pointer border overflow-x-hidden max-w-full rounded-md h-16 z-10 text-gray-500 font-semibold w-full text-right overflow-hidden";

const formatter = Intl.NumberFormat("en-US");

function CharInlineField({ attrs, data }) {
  const {
    name,
    readOnly,
    placeholder,
    onChange,
    translate,
    uppercase,
    msg,
    label,
    layout,
    icon,
    specialCharacters,
    type,
    autoFocus = false,
  } = attrs;

  let _value = data.value || "";

  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (autoFocus) {
      focusInput();
    }
  }, [autoFocus]);

  if (_value && layout && translate) {
    const _valueRef = `${layout.model}.${_value}`;
    _value = intl.msgs[_valueRef] || _value;
  }

  let _color;
  if (readOnly) {
    _color = colors.readOnly;
  }

  let _style = focused ? "border-blue-600" : "border-gray-300";

  function handleChange(event) {
    let newValue = event.target.value;
    if (uppercase) {
      newValue = newValue.toUpperCase();
    }
    if (specialCharacters && type === "char") {
      newValue = newValue.replace(/[^\w\s]|[\dñ]/gi, "");
      newValue = newValue.replace("  ", " ").toUpperCase();
    }
    data.value = type == "number" ? Number(newValue) : newValue;
    if (onChange) {
      onChange(name, newValue);
    }
  }

  function handleEvent(e) {
    if (e.key === "Delete") {
      onChange({ target: { value: "" } });
    }
  }

  function onBlur() {
    setFocused(false);
    if (onChange) {
      onChange(name, _value);
    }
  }

  function focusInput() {
    setFocused(true);
    const inputElement = document.getElementById(name);
    if (inputElement) {
      inputElement.focus();
      const length = inputElement.value.length;
      inputElement.setSelectionRange(length, length);
    }
  }

  let valueFmt = _value;
  if (type === "number") {
    valueFmt = formatter.format(_value);
  }

  return (
    <div className="flex items-center justify-center space-x-5 w-full mt-4 mb-1 min-h-12 max-w-2xl mx-auto">
      <div className="text-2xl font-bold text-zinc-500 w-3/6 text-right">
        <FM id={label} key={name} />
      </div>
      <div className="w-full overflow-x-hidden">
        <div className={cn(style, _style)} onClick={focusInput}>
          {valueFmt}
        </div>
        <input
          key={name}
          id={name}
          name={name}
          type="text"
          value={_value}
          onChange={handleChange}
          onBlur={onBlur}
          onKeyDown={handleEvent}
          disabled={readOnly ?? false}
          placeholder={placeholder ?? ""}
          title={msg ?? ""}
          className="absolute opacity-0 bg-white"
        />
      </div>
      <span>{icon || null}</span>
    </div>
  );
}

export default CharInlineField;
